export default "__VITE_ASSET__DQ5OvfwY__"